import { render, staticRenderFns } from "./PurchaseSuggestions.vue?vue&type=template&id=ad118508&"
import script from "./PurchaseSuggestions.vue?vue&type=script&lang=js&"
export * from "./PurchaseSuggestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports